import { useCheckPermissions } from '@/shared';
import { SaveActivos } from '../../shared/saveActivos';
import { PermissionsEnum } from '@/auth/interfaces';

export type CreateActivosPageProps = {};

const CreateActivosPage: React.FC<CreateActivosPageProps> = () => {
  
  useCheckPermissions(PermissionsEnum.api_add_activo);
  return <SaveActivos titlePage="Crear Activos" />;
};

export default CreateActivosPage;
